import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Box, Container, Grid, InputBase, Skeleton, styled, IconButton, Typography, Button, Drawer, Stack, keyframes} from '@mui/material';
import { ArrowBack, CloseRounded, FormatListBulleted, SearchRounded, GridView } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchCourse } from '../../hooks/useSearchCourse';
import { reduxHelper } from '../../config/reduxHelper';
import NoDataComponent from '../../components/nodata/nodata';
import Page from '../../components/Page';
import BundlesCard from '../../components/bundlecard/bundlescard.js';
import ProgramsCard from '../../components/programcard/ProgramsCard';
import CourseFilters from '../../components/search/courseFilters';
import useDevice from '../../hooks/useDevice';
import { useRouter } from 'next/router';
import Iconify from '../../components/Iconify.js';
import { icons } from '../../config/icons.js';


// function starts

const views = [
    { key: 'list', icon: <FormatListBulleted /> },
    { key: 'grid', icon: <GridView /> },
];

const wave = keyframes` 0%, 60%, 100% { transform: translateY(0); opacity: .6; } 30% { transform: translateY(-6px); opacity: 1; }`;

const Dot = styled("span")(({ theme }) => ({
  width: 10,
  height: 10,
  margin: "0 4px",
  borderRadius: "50%",
  background: "currentColor",
  animation: `${wave} 1.2s ease-in-out infinite`,
  "&:nth-of-type(2)": { animationDelay: "0.15s" },
  "&:nth-of-type(3)": { animationDelay: "0.3s" },
}));

// function starts

export default function AllCoursesNew() {
    const dispatch = useDispatch();
    const { query, replace, pathname } = useRouter();

    const { headers, searchPrograms } = useSelector(s => s.reducer);
    const [searchText, setSearchText] = useState(query.q || '');
    const [view, setView] = useState(query.view || 'grid');
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [result, setResults] = useState([]);

    const [offset, setoffset] = useState(1)
    const [hasMore, setHasMore] = useState(true);
    const [loadingNext, setLoadingNext] = useState(false);
    const wasAtBottom = React.useRef(false);

    const [openFilters, setOpenFilters] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const { isMobile, isTablet, isDesktop } = useDevice();

    const effectiveView = isDesktop ? view : 'grid';

    // const SearchBar = styled(Stack)(({ theme }) => ({
    //     display: 'flex',
    //     alignItems: 'center',

    //     border: '1px solid #7f7f7f',
    //     borderRadius: 24,
    //     padding: '0 8px',
    //     height: isMobile ? 35 : "40px",
    //     flex: 1,
    // }));





    useEffect(() => {
        const search = setTimeout(() => {
            replace(
                { pathname, query: { ...query, q: searchText } },
                undefined,
                { shallow: true }
            );
        }, 500);
        return () => clearTimeout(search);
    }, [searchText]);


    useEffect(() => {
        setSearchText(query.q || '')
    }, [query?.q]);


    const searchCourse = async () => {

        if(offset ==1){
            setIsLoading(true)
        }
        const callId = ++reqRef.current;  
        
        const {data}= await useSearchCourse(headers, `${searchText}&direction=${query?.order || 'asc'}&order_by=item_name&category_ids=${query?.c_id || ''}&sub_category_ids=${query?.sub_id || ''}&type=${query?.type || 'courses'}&tag=${encodeURIComponent(query?.tag || '')}&language=${query.language || ''}&duration=${query.duration || ''}&limit=${9}&offset=${offset}`)
        if (callId !== reqRef.current) return; 

        setResults(prev => [...prev, ...data]);

        setHasMore(data.length === 9 );

        dispatch({
          type: reduxHelper.UPDATE_SEARCH_PROGRAMS,
          payload: data,
        })

        if(offset == 1){
            setIsLoading(false)
        }else{
            setLoadingNext(false)
        }
        
    }


    useEffect(() => {
        const onScroll = () => {
            const bottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;

            if (bottom && !wasAtBottom.current && !loadingNext && hasMore) {
            setLoadingNext(true);
            setoffset(p => p + 1);   
            }
            wasAtBottom.current = bottom;
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [loadingNext, hasMore]);

    const reqRef   = useRef(0);

    const goBack = ()=> {
        if (query?.redirect_url){
            
            const decodedUrl = atob(decodeURIComponent(query.redirect_url))
            window.location.href = decodedUrl

        }else{
            history.back()
        }
    }

    useEffect(() => {
        reqRef.current++; 
        setIsLoading(true); 
        setResults([]);
        setoffset(1);
        setHasMore(true);
        setLoadingNext(false);
        wasAtBottom.current = false;
        window.scrollTo({ top: 0, behavior: "auto" });
    }, [query?.q ?? "", query.c_id, query.sub_id, query.type, query.order, query.tag, query.language, query.duration]);


    useEffect(() => {
        searchCourse()
    }, [query?.q ?? "", query.c_id, query.sub_id, query.type, query.order, query.tag, query.language, query.duration, offset])

    

    return (
        <Page title="Course catalog">
            <Container maxWidth={false} sx={{ maxWidth: "1700px", }}>
                <Box  sx={{  position: "sticky",  top: 0,    zIndex: 5,   backgroundColor: "#fff",py: { xl: "40px", xs: "25px " } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',  }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <IconButton><ArrowBack onClick={goBack} sx={{ fontSize: "18px"}} /></IconButton> 
                            <Typography sx={{ fontWeight: 500, fontSize: isMobile ? "16px" : "18px" }}>Course catalog</Typography>
                        </Box>

                        {isDesktop ? (
                            <Box sx={{ display: 'flex', gap: "25px" }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: '1px solid #7f7f7f',
                                    borderRadius: 24,
                                    padding: '0 8px',
                                    height: isMobile ? 35 : "40px",
                                    flex: 1,
                                }}>
                                    <SearchRounded color="action" sx={{ margin: "0 10px" }} />
                                    <InputBase placeholder="Search" value={searchText} onChange={e => setSearchText(e.target.value)} sx={{ width: "310px" }} />
                                    {searchText && (
                                        <IconButton size="small" onClick={() => setSearchText('')}>
                                            <CloseRounded fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                                <Box sx={{ borderRadius: '999px', border: '1px solid #7f7f7f', overflow: 'hidden', display: 'flex' }}>
                                    {views.map(({ key, icon }, i) => (
                                        <Button key={key} onClick={() => {
                                            setView(key)
                                            replace (
                                                { pathname, query : {...query, view :key}}, undefined, {shallow: true})
                                        }}
                                            sx={{
                                                width: "85px",
                                                borderRadius: 0,
                                                bgcolor: view === key ? '#e6f0ff' : 'transparent',
                                                color: view === key ? '#1976d2' : 'text.primary',
                                                '&:hover': { bgcolor: '#e6f0ff' },
                                                ...(i === 0 && { borderRight: '1px solid #7f7f7f' })
                                            }}
                                        >
                                            {icon}
                                        </Button>
                                    ))}
                                </Box>
                            </Box>
                        ) : (
                            <IconButton size="small" onClick={() => setShowSearchBar(b => !b)}>
                                <SearchRounded />
                            </IconButton>
                        )}
                    </Box>
                    {(isMobile || isTablet) && showSearchBar && (
                        <Box>
                            <Box sx={{
                                marginTop: isTablet ? "30px" : "20px", display: 'flex',
                                alignItems: 'center',
                                border: '1px solid #7f7f7f',
                                borderRadius: 24,
                                padding: '0 8px',
                                height: isMobile ? 35 : "40px",
                                flex: 1,
                            }}>
                                <SearchRounded color="action" sx={{ margin: "0 10px" }} />
                                <InputBase placeholder="Search" value={searchText} onChange={e => setSearchText(e.target.value)} sx={{ width: '100%' }} />
                                {searchText && (
                                    <IconButton size="small" onClick={() => setSearchText('')}>
                                        <CloseRounded fontSize="small" />
                                    </IconButton>
                                )}
                            </Box>
                        </Box>
                    )}
                </Box>

                

                <Grid container spacing={2} >
                    {isDesktop && (
                        <Grid item md={isDesktop ? 2.5 : 12} >
                            {/* <CourseFilters/> */}
                            <Box sx={{ position: 'sticky',top:70,  height:"85vh", overflowY:"auto",  scrollbarWidth: 'none',  '&::-webkit-scrollbar': { display: 'none' }, }}>
                                 <CourseFilters />
                            </Box>
                        </Grid>
                    )}
                    {!isDesktop && (
                        <Grid item xs={12}>
                            {/* <Button
                                size='large'
                                sx={{ width: isMobile ? 100 : 150 }}
                                startIcon={<FormatListBulleted />}
                                variant="outlined"
                                onClick={() => setOpenFilters(true)}
                            >
                                Filter
                            </Button> */}

                            <Box sx={{display:"flex", gap:2,border:"1px solid #ddd", p:2, borderRadius:1, width:isMobile?120:130, cursor:"pointer"}} onClick ={()=> setOpenFilters(true)}>
                                <Iconify icon={icons.SIMPLE_FUNNEL} sx={{fontSize:25}}/>
                                <Typography>Filter</Typography>
                            </Box>

                            {/* <FormControl size="small" sx={{ minWidth: 140 }}>
                                    <InputLabel>Sort by</InputLabel>
                                    <Select
                                        value={order}
                                        label="Sort by"
                                        onChange={e => setOrder(e.target.value)}
                                    >
                                        <MenuItem value="asc">Most Relevant</MenuItem>
                                        <MenuItem value="desc">Price: High to Low</MenuItem>
                                    </Select>
                                </FormControl> */}

                        </Grid>
                    )}
                    <Grid item xs={12} md={isDesktop ? 9.5 : 12}>
                        <Grid container spacing={2} alignItems="stretch">
                            {isLoading &&
                                Array.from({ length: 9}).map((_, i) => (
                                    <Grid
                                        item
                                        key={i}
                                        xs={12}
                                        sm={4}
                                        md={effectiveView === 'grid' ? 4 : 12}
                                    >
                                        {effectiveView === 'grid' ? (
                                            <>
                                                <Skeleton variant="rectangular" height={160} />
                                                <Skeleton width="60%" sx={{ mt: 1 }} />
                                                <Skeleton width="40%" sx={{ mt: 1 }} />
                                            </>
                                        ) : (
                                            <Stack direction="row" spacing={2} alignItems="center" sx={{ py: 1 }}>
                                                <Skeleton variant="rectangular" width={220} height={110} />

                                                <Box flexGrow={1}>
                                                    <Skeleton width="50%" height={24} />
                                                    <Skeleton width="40%" height={20} sx={{ mt: 0.5 }} />
                                                    <Skeleton width="30%" height={20} sx={{ mt: 0.5 }} />
                                                </Box>

                                                <Skeleton variant="rectangular" width={100} height={36} />
                                            </Stack>
                                        )}
                                    </Grid>
                                ))
                            }
                            {!isLoading && result.length === 0 && (
                                <Grid item xs={12}>
                                    <Box textAlign="center" mt={8}>
                                        <NoDataComponent
                                            title="Nothing found"
                                            description="Try adjusting your search or filters"
                                        />
                                    </Box>
                                </Grid>
                            )}

                            {!isLoading &&result.map((item, idx) => (
                                <Grid item key={idx} xs={12} sm={6} md={effectiveView === "grid" ? 4 : 12} sx={{ mb: "20px" }}>
                                    {item.pb_type === "1" || item.pb_type === "3" ? (
                                        <ProgramsCard item={item} index={idx} view={effectiveView} />
                                        ) : (
                                        <BundlesCard item={item} index={idx} view={effectiveView} />
                                    )}
                                </Grid>
                            ))}

                            {loadingNext && (
                                <Grid item xs={12}>
                                    <Box  sx={{display: "flex", justifyContent: "center", color: "primary.main",pb:"50px"}}>
                                        <Dot /> <Dot /> <Dot />
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            {(isTablet || isMobile) &&
                <Drawer anchor="right" open={openFilters} onClose={() => { setOpenFilters(false); setIsLoading(false); }} BackdropProps={{ sx: {zIndex: 20}}} PaperProps={{ sx: { width: isMobile ? "70vw" : "50vw", boxShadow: 3, overflow: 'visible' }} }>
                    <Box sx={{ pl: 2 }}>
                        <IconButton onClick={() => setOpenFilters(false)} aria-label="Close" sx={{ position: 'absolute', top: 16, left: -52, borderRadius: '50%', bgcolor: 'background.paper', }}>
                            <CloseRounded />
                        </IconButton>
                        <Box sx={{ height: '95vh', overflowY: 'auto', py: 2, }}>
                            <CourseFilters onApply={() => setOpenFilters(false)} />
                        </Box>
                    </Box>
                </Drawer>

            }
        </Page>
    );
}
